/**
 * English story blob from crossword or grid GET `/v1/puzzle/{cross|grid}-tpl/:id`.
 * Backend `story` includes `en` ({ title, text }) and typically `fr` for French templates.
 * Optional legacy: `storyJson.stories.en` / `.fr`.
 * For UI titles/body by template language use {@link getLocalizedStoryFromTemplate}.
 */
export function getEnStoryFromTemplate(r) {
    if (!r) return { en: null, imagePrompt: "", imageUrl: "" };
    const story = r.story;
    const en =
        story?.en ??
        r?.storyJson?.stories?.en ??
        null;
    const imagePrompt =
        typeof story?.imagePrompt === "string" ? story.imagePrompt : "";
    const imageUrl =
        typeof story?.imageUrl === "string"
            ? story.imageUrl
            : typeof r.imageUrl === "string"
              ? r.imageUrl
              : "";
    return { en, imagePrompt, imageUrl };
}

/** True when crossword/grid template GET uses French as primary language. */
function isTemplateFrench(r) {
    const lang = String(r?.language ?? "").toLowerCase();
    return lang === "french" || lang === "fr";
}

/**
 * Primary story title/text for UI: French templates → `story.fr` (legacy: `storyJson.stories.fr`);
 * English (and unknown) → `story.en`.
 * If French is selected but `fr` is empty, falls back to `en`.
 */
export function getLocalizedStoryBodyFromTemplate(r) {
    if (!r) return { title: "", text: "" };
    const story = r.story;
    const useFr = isTemplateFrench(r);

    let block = useFr
        ? story?.fr ?? r?.storyJson?.stories?.fr ?? null
        : story?.en ?? r?.storyJson?.stories?.en ?? null;

    let title = typeof block?.title === "string" ? block.title.trim() : "";
    let text = typeof block?.text === "string" ? block.text.trim() : "";

    if (useFr && !title && !text) {
        const en = story?.en ?? r?.storyJson?.stories?.en ?? null;
        title = typeof en?.title === "string" ? en.title.trim() : "";
        text = typeof en?.text === "string" ? en.text.trim() : "";
    }

    return { title, text };
}

/**
 * Localized title/text plus shared illustration fields (`imagePrompt`, `imageUrl` same as English helper).
 */
export function getLocalizedStoryFromTemplate(r) {
    const { imagePrompt, imageUrl } = getEnStoryFromTemplate(r);
    const { title, text } = getLocalizedStoryBodyFromTemplate(r);
    return { title, text, imagePrompt, imageUrl };
}
